
import { cartApproverMessageStyles } from "@insite/content-library/Widgets/Common/CartApproverMessage";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartApproverMessageStyles.approvingWrapper = {
    css: css`
        margin: 10px 0;
        text-align: center;
        padding: 10px;
        background-color: ${getColor("info.main")};
    `
}